import { createSelector } from 'redux-orm';
import { orm } from 'model';

export const selector = createSelector(
  orm,
  (state, props) => props,
  ({ Payer }, { payerId }) => {
    return Payer.idExists(payerId)
      ? Payer.withId(payerId).payerNotes.toRefArray()
      : [];
  }
);

export const selectorId = createSelector(orm.PayerNotes);
